import { HomeHeader } from "./HomeHeader";
import { SearchBar } from "./SearchBar";
import { NewArrivals } from "./NewArrivals";
import { BottomNavigation } from "../ui/BottomNavigation";
import { PromotionalBannersSmall } from "./PromotionalBannersSmall";
import { PromotionalBannersLong } from "./PromotionalBannersLong";
import { Marquee } from "./Marquee";

enum BannerType {
  LONG = "long",
  SMALL = "small",
}

export const HomePage = () => {
  const bannerType = "long";

  return (
    <div className="min-h-screen w-full bg-white flex flex-col">
      {bannerType === BannerType.LONG && (
        <div className="w-full">
          <PromotionalBannersLong />
        </div>
      )}
      <Marquee />
      {/* Scrollable content area with proper spacing */}
      <div className="flex-1 overflow-y-auto pb-[70px] px-5 space-y-6">
        {bannerType !== BannerType.LONG && (
          <>
            <div className="pt-5 pb-3">
              <HomeHeader />
            </div>

            <SearchBar />

            {/* <PromotionalBanners /> */}
            <PromotionalBannersSmall />
          </>
        )}
        <NewArrivals />
      </div>

      {/* Fixed bottom navigation */}
      <BottomNavigation />
    </div>
  );
};
